import { render, staticRenderFns } from "./PublishedPostsPage.vue?vue&type=template&id=e48134f6&"
import script from "./PublishedPostsPage.vue?vue&type=script&lang=js&"
export * from "./PublishedPostsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports